import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'terms' | 'privacy' | null;
const termsContent = <>
    <h2 className="text-2xl font-serif font-bold text-navy mb-6" data-id="element-51">
      Términos y Condiciones
    </h2>

    <h3 className="text-lg font-bold text-navy mt-6 mb-2" data-id="element-52">
      1. Aceptación de los Términos
    </h3>
    <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-53">
      Al adquirir y utilizar el producto digital "Protocolo SOS: Crisis
      Sensorial", usted acepta estos términos y condiciones en su totalidad. Si
      no está de acuerdo con alguno de estos términos, no debe utilizar este
      producto.
    </p>

    <h3 className="text-lg font-bold text-navy mt-6 mb-2" data-id="element-54">
      2. Naturaleza del Producto
    </h3>
    <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-55">
      Este es un producto digital de carácter informativo y educativo. No
      constituye asesoramiento médico, terapéutico ni psicológico profesional.
      El contenido se basa en investigación sobre regulación sensorial y no
      reemplaza la evaluación o tratamiento por parte de profesionales de la
      salud.
    </p>

    <h3 className="text-lg font-bold text-navy mt-6 mb-2" data-id="element-56">
      3. Uso del Producto
    </h3>
    <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-57">
      El producto es para uso personal y no comercial. Queda prohibida su
      reproducción, distribución, modificación o reventa sin autorización
      expresa por escrito. El acceso es individual e intransferible.
    </p>

    <h3 className="text-lg font-bold text-navy mt-6 mb-2" data-id="element-58">
      4. Limitación de Responsabilidad
    </h3>
    <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-59">
      Los resultados pueden variar según el perfil sensorial de cada niño. No
      garantizamos resultados específicos. El usuario asume toda responsabilidad
      por la aplicación de las técnicas descritas. Se recomienda consultar con
      el equipo terapéutico del niño antes de implementar cambios
      significativos.
    </p>

    <h3 className="text-lg font-bold text-navy mt-6 mb-2" data-id="element-60">
      5. Propiedad Intelectual
    </h3>
    <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-61">
      Todo el contenido del Protocolo SOS, incluyendo textos, gráficos,
      checklists y metodologías, está protegido por derechos de autor. El uso no
      autorizado constituye una violación de la ley de propiedad intelectual.
    </p>

    <h3 className="text-lg font-bold text-navy mt-6 mb-2" data-id="element-62">
      6. Política de Reembolso
    </h3>
    <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-63">
      Debido a la naturaleza digital del producto y su entrega inmediata, todas
      las ventas son finales. No se ofrecen reembolsos una vez que el producto
      ha sido descargado o accedido.
    </p>

    <h3 className="text-lg font-bold text-navy mt-6 mb-2" data-id="element-64">7. Modificaciones</h3>
    <p className="text-gray-700 leading-relaxed" data-id="element-65">
      Nos reservamos el derecho de modificar estos términos en cualquier
      momento. Las modificaciones serán efectivas desde su publicación. El uso
      continuado del producto constituye la aceptación de los términos
      modificados.
    </p>
  </>;
const privacyContent = <>
    <h2 className="text-2xl font-serif font-bold text-navy mb-6" data-id="element-66">
      Política de Privacidad
    </h2>

    <h3 className="text-lg font-bold text-navy mt-6 mb-2" data-id="element-67">
      1. Información que Recopilamos
    </h3>
    <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-68">
      Al adquirir el Protocolo SOS, recopilamos únicamente la información
      necesaria para procesar su compra: nombre, dirección de correo electrónico
      y datos de pago. No recopilamos información sensible sobre usted ni sobre
      su hijo.
    </p>

    <h3 className="text-lg font-bold text-navy mt-6 mb-2" data-id="element-69">
      2. Uso de la Información
    </h3>
    <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-70">
      Su información se utiliza exclusivamente para: procesar y entregar su
      compra, enviar el producto digital adquirido, y comunicar actualizaciones
      importantes relacionadas con el producto. No vendemos, alquilamos ni
      compartimos su información personal con terceros con fines de marketing.
    </p>

    <h3 className="text-lg font-bold text-navy mt-6 mb-2" data-id="element-71">
      3. Protección de Datos
    </h3>
    <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-72">
      Implementamos medidas de seguridad técnicas y organizativas para proteger
      su información personal contra acceso no autorizado, alteración,
      divulgación o destrucción. Los pagos se procesan a través de plataformas
      seguras con encriptación SSL.
    </p>

    <h3 className="text-lg font-bold text-navy mt-6 mb-2" data-id="element-73">
      4. Cookies y Tecnologías de Seguimiento
    </h3>
    <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-74">
      Nuestro sitio puede utilizar cookies y tecnologías similares para mejorar
      la experiencia del usuario y analizar el tráfico del sitio. Puede
      configurar su navegador para rechazar cookies, aunque esto podría afectar
      la funcionalidad del sitio.
    </p>

    <h3 className="text-lg font-bold text-navy mt-6 mb-2" data-id="element-75">5. Sus Derechos</h3>
    <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-76">
      Usted tiene derecho a acceder, rectificar o eliminar su información
      personal. También puede solicitar la limitación del procesamiento de sus
      datos o ejercer su derecho a la portabilidad de datos conforme a las leyes
      aplicables.
    </p>

    <h3 className="text-lg font-bold text-navy mt-6 mb-2" data-id="element-77">
      6. Retención de Datos
    </h3>
    <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-78">
      Conservamos su información personal solo durante el tiempo necesario para
      cumplir con los fines para los que fue recopilada, incluyendo obligaciones
      legales y contables.
    </p>

    <h3 className="text-lg font-bold text-navy mt-6 mb-2" data-id="element-79">
      7. Cambios en esta Política
    </h3>
    <p className="text-gray-700 leading-relaxed" data-id="element-80">
      Nos reservamos el derecho de actualizar esta política de privacidad en
      cualquier momento. Cualquier cambio será publicado en esta página con la
      fecha de la última actualización.
    </p>
  </>;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-[#08182b] text-gray-400 py-12 px-6 text-sm text-center" data-id="element-81">
        <div className="max-w-4xl mx-auto space-y-6" data-id="element-82">
          <p className="leading-relaxed text-xs" data-id="element-83">
            <strong data-id="element-84">AVISO LEGAL Y DESCARGO DE RESPONSABILIDAD:</strong> Este
            producto digital tiene fines exclusivamente informativos y
            educativos. El contenido aquí presentado no sustituye el consejo
            médico profesional, diagnóstico o tratamiento de un neurólogo,
            terapeuta ocupacional o psicólogo clínico. La autora no es médico ni
            terapeuta licenciada. Los resultados individuales pueden variar
            según el perfil sensorial específico de cada niño. Al utilizar este
            protocolo, el lector asume toda la responsabilidad por la aplicación
            de las técnicas descritas.
          </p>
          <div className="flex justify-center gap-4 text-xs" data-id="element-85">
            <button onClick={() => setActiveModal('terms')} className="hover:text-white transition-colors underline underline-offset-2" data-id="element-86">
              Términos y Condiciones
            </button>
            <span data-id="element-87">|</span>
            <button onClick={() => setActiveModal('privacy')} className="hover:text-white transition-colors underline underline-offset-2" data-id="element-88">
              Política de Privacidad
            </button>
          </div>
          <p data-id="element-89">
            &copy; {new Date().getFullYear()} Protocolo SOS. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      {/* Modal */}
      <AnimatePresence data-id="element-90">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-91">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3
        }} className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-92">
              <div className="flex items-center justify-between p-6 border-b border-gray-100 sticky top-0 bg-white z-10" data-id="element-93">
                <span className="text-sm text-teal font-semibold uppercase tracking-wider" data-id="element-94">
                  {activeModal === 'terms' ? 'Términos y Condiciones' : 'Política de Privacidad'}
                </span>
                <button onClick={() => setActiveModal(null)} className="p-2 rounded-full hover:bg-gray-100 transition-colors" aria-label="Cerrar" data-id="element-95">
                  <X className="w-5 h-5 text-gray-500" data-id="element-96" />
                </button>
              </div>
              <div className="p-6 md:p-8 overflow-y-auto max-h-[calc(80vh-73px)]" data-id="element-97">
                {activeModal === 'terms' ? termsContent : privacyContent}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}